export function categorizeTransactions(transactions = [], txId) {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const completed = [];
  const ongoing = [];  // Transakcje, które są w trakcie
  const future = [];   // Transakcje, które jeszcze się nie rozpoczęły
  const overdue = [];
  const notPaidServiceFees = []

  transactions.filter(t => t.id.uuid !== txId).forEach(transaction => {
    const { processState, start, end, stolen } = transaction.attributes;

    // Przekształcamy daty na obiekty Date i odejmujemy 1 dzień od daty 'end'
    const endDate = new Date(end);
    endDate.setDate(endDate.getDate() - 1);
    const startDate = new Date(start);

    if (transaction.attributes.serviceFee) {
      notPaidServiceFees.push(transaction);
    } else {
      if (processState === 'delivered' && !stolen) {
        completed.push(transaction);
      } else if (processState !== 'delivered' && endDate >= today) {
        if (startDate <= today || processState === 'picked-up') {
          ongoing.push(transaction); // Transakcja trwa w tej chwili
        } else {
          future.push(transaction); // Transakcja jeszcze się nie zaczęła
        }
      } else if ((processState !== 'delivered' && endDate < today) || (stolen)) {
        overdue.push(transaction);
      }
    }
  });

  return { completed, ongoing, future, overdue, notPaidServiceFees };
}
